import { notificationsExtensionSlots } from '@sharefiledev/notification-center-pilet-sdk';
import type { PiletApi, PiletUserContext } from '@sharefiledev/sharefile-appshell';
import { configureNotifyHttp, setLogger } from './Common';
import {
	AsyncLazyDevPage,
	AsyncLazyDevPageIcon,
	AsyncLazyNotificationsCenter,
} from './extensions';

export function setup(app: PiletApi) {
	setLogger(app.sf.getLogger());

	app.registerExtension(notificationsExtensionSlots.bell, ({ params }) => {
		const context: PiletUserContext = app.sf.piletUserContext.get();

		if (!context.account.Preferences.EnableProjects) {
			return null; // Early return to avoid rendering on accounts without the projects feature enabled
		}

		return <AsyncLazyNotificationsCenter app={app} {...params} />;
	});

	if (process.env.NODE_ENV === 'development') {
		if (typeof app.meta.config.apiOrigin === 'string') {
			configureNotifyHttp(config => {
				config.origin = app.meta.config.apiOrigin + '/io/notify';
			});
		}

		app.sf.registerLeftNavComponent({
			href: '/NotifyDev',
			title: () => 'Notifications',
			icon: () => <AsyncLazyDevPageIcon size={24} />,
			weight: 50,
		});

		app.registerPage('/NotifyDev', () => <AsyncLazyDevPage app={app} />);
	}
}
